import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../auth/service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class OrgResolverService implements Resolve<void> {
  constructor(private authService: AuthService) {}

  resolve(route: ActivatedRouteSnapshot): void {
    const orgId = route.paramMap.get('orgId');
    if (orgId) {
      this.authService.setOrgFromPath(orgId);
    }
  }
}
